import { CSSProperties } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * TemplateEditor component styles
 * @returns {Function}
 */

const getFixedHeightAttrs = (height: string): CSSProperties => ({
  height,
  minHeight: height,
  maxHeight: height,
});

const getFixedWidthAttrs = (width: string): CSSProperties => ({
  width,
  minWidth: width,
  maxWidth: width,
});

export const useStyles = makeStyles((theme) =>
  createStyles({
    templateView: {
      ...getFixedHeightAttrs(`calc(100% + 2 * ${theme.spacing(3)}px)`),
      ...getFixedWidthAttrs(`calc(100% + 2 * ${theme.spacing(8)}px)`),
      display: 'flex',
      gap: '2.5rem',
      justifyContent: 'center', // 'space-between',
      position: 'relative',

      '& > *, & > * > *': {
        ...getFixedHeightAttrs('100%'),
      },

      '& > *:not(:first-child)': {
        // borderLeft: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      },

      width: '100%',
      minWidth: '100%',
      maxWidth: '100%',
      height: '100%',
      minHeight: '100%',
      maxHeight: '100%',
      overflow: 'hidden',
    } as any,

    leftPanel: {
      '&&': {
        width: '45rem',
        flex: '0 0 45rem',
        // marginRight: '1.4rem',
        maxWidth: 'unset',
        minWidth: 'unset',

        ['@media (min-width: 1024px) and (max-width: 1650px)']: {
          // width: '25rem',
          // flex: '0 0 25rem',
          flex: '0 0 calc((100% - 65.6rem)/2)',
          maxWidth: '44rem',
          minWidth: '25rem',
          width: 'calc((100% - 65.6rem)/2)',
        },
      },
    },

    centralPanel: {
      '&&': {
        maxWidth: 'none', // 'unset',
        minWidth: '600px', //0, // 'unset',
        position: 'relative',
        width: 'auto', //'60rem', // 'unset',
        // width: 'calc(100% - 67.2rem)',

        // ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        //   width: 'calc(100% - 49.2rem)',
        // },
      },
    },

    moduleHeader: {
      height: '4.7rem',
      minHeight: '47px',
    },

    rightPanel: {
      '&&': {
        width: '44.8rem',
        flex: '0 0 44.8rem',
        maxWidth: 'unset',
        minWidth: 'unset',
        borderLeft: 'unset',

        ['@media (min-width: 1024px) and (max-width: 1650px)']: {
          // flex: '0 0 27rem',
          flex: '0 0 calc((100% - 65.6rem)/2)',
          maxWidth: '44rem',
          minWidth: '27rem',
          width: 'calc((100% - 65.6rem)/2)',
        },
      },
    },

    rightPanelContent: {
      borderTop: 'unset',
      height: '63.7rem',
      right: 0,
      width: '45rem',
      zIndex: 1,

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        // width: '27rem',
        width: '100%',
      },
    },

    treatmentLogic: {
      position: 'absolute',
      width: 'calc(100% - 46.2rem)', //'calc(100% - 44.8rem)',
      marginRight: '1.4rem',
      maxWidth: 'unset',
      minWidth: 'unset',
      background: variables.color.primary.white,

      ['@media (min-width: 1024px) and (max-width: 1650px)']: {
        width: 'calc(100% - 28.2rem)!important', //'calc(100% - 26.8rem)!important',
      },
    },

    contentLibraryPanel: {
      // paddingTop: '6.3rem',
    },
  }),
);
